// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_Asb","scoreRing":"e_Bsb","badge":"e_Csb","badgeImage":"e_Dsb","spaced":"e_Esb"};